import { format } from "date-fns";

export function formatDate(date) {
    if (date) {
        date = date.replace('Z', '')
        const formattedDate = format(new Date(date), "do MMMM yyyy, HH:mm")
        return formattedDate
    }
}